<script>
import Swal from "sweetalert2";
import Fixtures from "../../../services/Fixtures";
import Football from "../../../services/Football";
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';


export default {
    components: { VueBootstrapTypeahead },


  data() {
    return {
      csrf_token: localStorage.getItem("csrf_token"),
      showModal: false,
      competition_id: null,
      season: null,
      tenant: process.env.VUE_APP_TENANT,
      venues: [],
      stages: [],
      teams:[],
      competitions: [],
      home_team_id: null,
      away_team_id: null,
      selectedVenue: null,
      selectedStage: null,
      datetime: null,
      seasons: [
        // {
        //   season_id: "0",
        //   season_name: "2022/2023",
        // },
        // {
        //   season_id: "1",
        //   season_name: "2023/2024",
        // },
        {
          season_id: "2",
          season_name: "2024/2025",
        },
      ],
      tryingToSubmit: false,
    };
  },
  created() {
    this.getSportTeams();
    this.getSportCompetitions();
  },
  mounted() {
   // this.getSportTeams();
    this.getVenues();
  // this.getSportCompetitions();
  },
  computed: {},
  watch: {
     competition_id(newVal) {
      // this.filterTeams(newVal);
       this.filterStages(newVal);
     },
   },
  methods: {
    async getSportCompetitions() {
      try {
        const response = await Fixtures.getSportCompetitions();
        this.competitions = response.data.competitions;
      } catch (error) {
        this.failedmsg(error.response.data.error);
      }
    },
    async getSportTeams() {
      try {
        var filters = 'team_sport=football&team_provider=1';
        const response = await Football.getSportTeams(filters);
        this.teams = response.data.teams;
      } catch (error) {
        this.failedmsg(error.response.data.error);
      }
    },

    onHomeTeamSelected(selectedTeam) {
        this.home_team_id = selectedTeam.team_id;
    },

    onAwayTeamSelected(team) {
        this.away_team_id = team.team_id;
    },

    onVenueSelected(venue) {
    this.selectedVenue = venue;
    },

    async getVenues() {
      try {
        const response = await Fixtures.getVenues();
        this.venues = response.data;
      } catch (error) {
        this.failedmsg(error.response.data.error);
      }
    },
    filterTeams(competitionId) {
      const competition = this.competitions.find(
        (c) => c.competition_id === competitionId
      );

      if (competition) {
        const tenantTeam = competition.teams.find(
          (team) => team.team_code === this.tenant
        );

        const otherTeams = competition.teams.filter(
          (team) => team.team_code !== this.tenant
        );

        this.teams = tenantTeam ? [tenantTeam, ...otherTeams] : otherTeams;
      } else {
        this.teams = [];
      }
    },
    filterStages(competitionId) {
      const competition = this.competitions.find(
        (c) => c.competition_id === competitionId
      );
      this.stages = competition ? competition.stages : [];
    },
    async addSportMatch() {
      const payload = {
        competition_id: this.competition_id,
        season: this.season,
        homeTeam: this.home_team_id,
        awayTeam: this.away_team_id,
        venueId: this.selectedVenue.venue_id,
        venueName: this.selectedVenue.venue_name,
        datetime: this.datetime,
        stageId: this.selectedStage.stage_id,
        stageName: this.selectedStage.stage_name,
      };
      try {
        this.tryingToSubmit = true;
        const response = await Fixtures.addSportMatch(payload);
        this.successmsg();
       // this.$emit("success", response.data.data.match);
        this.$emit('refreshData');
        this.closeModal();
        this.tryingToSubmit = false;
      } catch (error) {
      //  console.log(error);
        this.failedmsg(error.response.data.error);
        this.tryingToSubmit = false;
      }
    },
    closeModal() {
      this.showModal = false;
    },
    successmsg() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: `Match added!`,
        showConfirmButton: false,
        timer: 2000,
      });
    },

    failedmsg(msg) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 50000,
      });
    },
  },
};
</script>

<template>
  <b-modal
    id="add_match"
    v-model="showModal"
    title="Add Friendly Match"
    title-class="text-black font-18"
    body-class="p-3"
    hide-footer
    centered
  >
    <form @submit.prevent="addSportMatch">
      <div class="row">
        <div class="col-12">
            <div class="mb-3">
              <label class="control-label form-label">Select Competition</label>
              <select
                v-model="competition_id"
                class="form-control form-select"
                name="competition_id"
                type="select"
              >
                <b-form-select-option :value="null"
                  >Please select competition</b-form-select-option
                >
                <option
                  v-for="competition in competitions"
                  :key="competition.competition_id"
                  :value="competition.competition_id"
                >
                  {{ competition.competition_name }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label class="control-label form-label">Select Stage</label>
              <select
                v-model="selectedStage"
                class="form-control form-select"
                name="stage"
                type="select"
              >
                <b-form-select-option :value="null"
                  >Please select stage</b-form-select-option
                >
                <option
                  v-for="stage in stages"
                  :key="stage.stage_id"
                  :value="stage"
                >
                  {{ stage.stage_name }}
                </option>
              </select>
            </div>

        <!-- <option
            <div class="mb-3">
              <label class="control-label form-label">Select Season</label>
              <select
                v-model="season"
                class="form-control form-select"
                name="season"
                type="select"
              >
                <b-form-select-option :value="null"
                  >Please select a season</b-form-select-option
                >

                  v-for="season in seasons"
                  :key="season.season_id"
                  :value="season.season_name"
                >
                  {{ season.season_name }}

              </select>
          </div>
           </option> -->

          <div class="mb-3">
            <label class="control-label form-label">Select Home Team</label>
             <vue-bootstrap-typeahead
               :data="teams"
               :serializer="team => team.team_name"
               :minMatchingChars="1"
               placeholder="Select home team"
               @hit="onHomeTeamSelected"
             />
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Select Away Team</label>
             <vue-bootstrap-typeahead
               :data="teams"
               :serializer="team => team.team_name"
               :minMatchingChars="1"
               placeholder="Select away team"
               @hit="onAwayTeamSelected"
             />
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Select Venue</label>
            <vue-bootstrap-typeahead
              :data="venues"
              :serializer="venue => venue.venue_name"
              :minMatchingChars="1"
              placeholder="Select venue"
              @hit="onVenueSelected"
            />
          </div>

          <div class="mb-3">
            <label class="control-label form-label">Select Date</label>
            <input
              class="form-control"
              v-model="datetime"
              type="datetime-local"
              name="datetime"
            />
          </div>
        </div>
      </div>

      <div class="text-end pt-5 mt-3">
        <b-button variant="light" @click="closeModal">Close</b-button>
        <b-button
          type="submit"
          variant="primary"
          class="ms-3"
          :disabled="tryingToSubmit"
        >
          {{ tryingToSubmit ? "Loading..." : "Submit" }}
        </b-button>
      </div>
      <input type="hidden" name="csrf_token" v-model="csrf_token" />
    </form>
  </b-modal>
</template>
